<app-modal
  #modal
  (isDismissing)="closeModal()"
  [modalConfig]="{
    headerClass: ['modal-header', 'bg-primary', 'text-white'],
    customFooter: true,
    showFooter: false,
    titleText: 'Survey',
    options: {
      size: 'lg'
    }
  }">
  <button
    class="btn btn-closemodal"
    title="Close"
    aria-label="close"
    headerContent
    (click)="closeModal()">
    <i class="bi bi-x-lg text-white"></i>
  </button>
  <div class="px-5 py-4">
    <app-proforms-form
      [formId]="formId"
      [context]="contextType"
      [contextId]="sessionId"
      [viewState]="viewStates.EDIT"
      (formSubmitted)="onFormSubmit($event)" />
  </div>
</app-modal>
